import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios, { getParams } from '@utils/request'
import { IListCRMPayload } from '@app-store/slices/crm/list'

interface TaskAction extends Action {
    payload: IListCRMPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.crm.list

function* listCRMSagaTask({ payload }) {
    const params = yield getParams(payload)
    try {
        const response = yield axios.get(`/integrations/crms`, {
            params
        })
        if (response.success) {
            yield put(onSuccess(response.result))
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* listCRMSaga(): any {
    yield takeLatest<TaskAction>(onRequest, listCRMSagaTask)
}

export default listCRMSaga
